import { Chip, Grid, MenuItem, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { allIcons } from "../../../assets";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import Label from "../../../components/Label";

function ProvideService(props) {
  const {
    handleChangeTab,
    serviceData,
    setSelectedServices,
    setSelctedID,
    selectedID,
    formData,
    selectedServices,
    selectedCategory,
    handleFetchAllServices,
    setSelectedCategory,
  } = props;

  console.log(formData, "selectedIDselectedIDselectedID");

  const [errors, setErrors] = useState({ category: false, service: false });

  useEffect(() => {
    handleFetchAllServices();
  }, []);

  const handleSelectService = (e) => {
    let temppArrrr = [...selectedID];
    const selectedService = selectedCategory.services.find(
      (service) => service.serviceName === e.target.value?.serviceName
    );

    if (selectedService && !selectedServices.includes(selectedService)) {
      setSelectedServices((prevServices) => [...prevServices, selectedService]);
      temppArrrr.push(selectedService?._id);
      setSelctedID(temppArrrr);
    }

    setErrors((prev) => ({ ...prev, service: false }));
  };

  const handleDeleteChip = (serviceToDelete) => {
    setSelectedServices((prevServices) =>
      prevServices.filter(
        (service) => service.serviceName !== serviceToDelete.serviceName
      )
    );
    setSelctedID((prevIds) =>
      prevIds.filter((serviceId) => serviceId !== serviceToDelete._id)
    );
  };

  const handleSelectCategory = (e) => {
    setSelectedCategory(e.target.value);
    setErrors((prev) => ({ ...prev, category: false }));
  };

  const validateAndProceed = () => {
    let validationErrors = { category: false, service: false };
    if (!selectedCategory) {
      validationErrors.category = true;
    }
    if (selectedServices.length === 0) {
      validationErrors.service = true;
    }

    setErrors(validationErrors);

    if (!validationErrors.category && !validationErrors.service) {
      handleChangeTab("teamMembersTimings");
    }
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"Save & Next"}
          handleClickBtn={validateAndProceed}
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            height: 40,
            width: 130,
          }}
          disabled={!selectedCategory || selectedServices.length === 0}
        />
      </Stack>
    );
  };

  return (
    <>
      <AppContainer
        primaryHeading={"Services"}
        secondaryHeading={"Choose the services this team member provides."}
        headProps={renderRightPart()}
        showBackButton
        handleBack={() => handleChangeTab("addNewMember")}
        childrenProps={{
          sx: {
            padding: { xs: "10px 20px", md: "20px 50px" },
            paddingBottom: "50px !important",
          },
        }}
      >
        <Grid container spacing={2} alignItems={"flex-end"}>
          <Grid item xs={12} md={4}>
            <Label labelText="Filter by category" required />
            <CustomDropDown
              size={"small"}
              onChange={handleSelectCategory}
              icon={
                <img
                  src={allIcons.briefcaseIcon}
                  alt={"category-icon"}
                  width={20}
                />
              }
              error={errors.category}
            >
              {serviceData?.map((category, ind) => (
                <MenuItem key={ind} value={category}>
                  {category?.name}
                </MenuItem>
              ))}
            </CustomDropDown>
          </Grid>

          {selectedCategory?.services?.length > 0 && (
            <Grid item xs={12} md={4}>
              <Label labelText="Filter by service" required />
              <CustomDropDown
                size={"small"}
                onChange={handleSelectService}
                error={errors.service}
              >
                {selectedCategory?.services?.map((service, ind) => (
                  <MenuItem key={ind} value={service}>
                    {service.serviceName}
                  </MenuItem>
                ))}
              </CustomDropDown>
            </Grid>
          )}

          <Grid item xs={12} md={8}>
            {selectedServices?.map((service, ind) => (
              <Chip
                sx={{ ml: 1 }}
                color="primary"
                key={ind}
                label={`${service?.serviceName} - ${service.price} SAR`}
                onDelete={() => handleDeleteChip(service)}
              />
            ))}
          </Grid>
        </Grid>
      </AppContainer>
    </>
  );
}

export default ProvideService;
